import React, { useState } from "react";
import { notifyError, notifySuccess } from "../../helper";
import { useParams,Link } from "react-router-dom";
import client from "../../api";


const SequenceMessagePreview = (props) => {
    const {campaignID} = useParams('');
    const api = client();
    const data = props;
    const [fullHeight,setFullHeight] = useState(false);
    const [loading, setLoading] = useState(false);
    const toggleHeight = () => {
        setFullHeight(!fullHeight);
    }
    const changeStepStatusToPause = async (stepId) => {
        setLoading(true);
        try {
            const payload = {
                campaignID:campaignID,
                stepID:stepId
            }
            
            const response = await api.post('/v1/campaign/steps/pause',payload);
            if(response.status === 200 || response.status === 201){
                setLoading(false);
                notifySuccess(response.data.message);
                setTimeout(()=>{
                    window.location.reload();
                }, 1500);
            }
        } catch (error) {
            setLoading(false);
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request. Unable to change step status. Please try again');
        }
    }
    const changeStepStatusToStart = async (stepId) => {
        setLoading(true);
        try {
            const payload = {
                campaignID:campaignID,
                stepID:stepId
            }
            
            const response = await api.post('/v1/campaign/steps/enable',payload);
            if(response.status === 200 || response.status === 201){
                setLoading(false);
                notifySuccess(response.data.message);
                setTimeout(()=>{
                    window.location.reload();
                },1500);
            }
        } catch (error) {
            setLoading(false);
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request. Unable to change step status. Please try again');
        }

    }
        
    return(<>
        {data.index !== 0 && <div className="seq-connect">
            <div className="seq-circle">
                <span>{data?.step?.minimum_delay_after_last_send}</span>
                <span>days</span>
            </div>
        </div>}

        <div className="seq-step">
            <div className="current-status">
                {data?.step?.status === "active" && <button onClick={()=>{changeStepStatusToPause(data?.step?.step_id)}}><span title="click to pause">{loading ? <div className="loader"></div> : <i className="bx bx-pause"></i>}</span></button>}
                {data?.step?.status === "pause" && <button onClick={()=>{changeStepStatusToStart(data?.step?.step_id)}}><span title="click to start">{loading ? <div className="loader"></div> : <i className="bx bx-play"></i>}</span></button>}
            </div>
            <div className="seq-step-inner" onClick={()=>{toggleHeight()}}>
                <div className="step-link">
                    <div class="message-no"><i className='bx bx-envelope'></i>  {data.index === 0 ? 'Initial campaign email':'Follow-up'}</div>
                </div>
                <div className="step-subject">{data?.step?.subject}</div>
                {/* <div className="step-title">Hi First Name RB W42 2024:there,</div> */}
                <div className={fullHeight ? 'full-view step-message' :'step-message' }>
                    {props?.messageType === 'text/plain' ? <pre className="pre-msj"><div dangerouslySetInnerHTML={{__html:data?.step?.body}}></div></pre> : <div dangerouslySetInnerHTML={{__html:data?.step?.body}}></div>}
                </div>
            </div>
        </div>
    </>);
}
export default SequenceMessagePreview;